export default "__VITE_ASSET__uLyCxx62__"